// import Firebase from './src/components/Firebase'
import "./src/styles/global.css"

const CACHE_MIGRATION_VERSION = `offline-worker-retired-1`

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }

  if (
    process.env.NODE_ENV === `production` &&
    window.localStorage.getItem(`cache-migration`) !== CACHE_MIGRATION_VERSION
  ) {
    const registrations = `serviceWorker` in navigator
      ? await navigator.serviceWorker.getRegistrations()
      : []
    const cacheNames = `caches` in window ? await window.caches.keys() : []

    await Promise.all([
      ...registrations.map(registration => registration.unregister()),
      ...cacheNames.map(cacheName => window.caches.delete(cacheName)),
    ])

    window.localStorage.setItem(`cache-migration`, CACHE_MIGRATION_VERSION)

    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      window.location.reload()
    }
  }
}

export const onRouteUpdate = () => {
  // Don't track while developing.
  if (process.env.NODE_ENV === `production` && typeof fbq === `function`) {
    // eslint-disable-next-line no-undef
    fbq("track", "ViewContent");
  }
};

// export const wrapRootElement = ({ element, props }) => (
//   <Firebase
//     {...props}
//   >
//     {element}
//   </Firebase>
// );
